module.exports = __webpack_public_path__ + "/login_ui/img/in-a15842a6a6e5e0eedb992d788384d724.svg";